import cx from 'classnames';
import React, { forwardRef, useRef } from 'react';
import { Transition } from 'react-transition-group';
import { TransitionCallbacks } from 'react-overlays/cjs/types';
import styles from './SlideOutPanel.module.scss';

// Define your props explicitly
type FadeTransitionProps = {
  in: boolean;
  appear?: boolean;
  unmountOnExit?: boolean;
  children?: React.ReactElement<any>;
} & TransitionCallbacks;

export const FadeTransition = forwardRef<HTMLDivElement, FadeTransitionProps>(
  ({ children, ...props }, ref) => {
    const nodeRef = useRef(null); // Used for nodeRef prop (optional)

    return (
      <Transition
        timeout={300}
        {...props}
        nodeRef={nodeRef} // Prevents use of findDOMNode
      >
        {(state) =>
          children
            ? React.cloneElement(children, {
                ref: ref ?? nodeRef,
                className: cx(children.props.className, styles[state]),
              })
            : null
        }
      </Transition>
    );
  }
);